var map = {
	"./error.mp3": "xONB",
	"./success.mp3": "Uz62"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vgXv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio ^\.\/.*\.mp3$
// module id = vgXv
// module chunks = 300